<template>
<div class="chapter">
<div class="inner_page">
<div class="frontMatterPage" id="prefacepage">
<a id="page08">
</a><a id="page09">
</a><div class="chapterHead"><a id="page09">
</a><h2 class="chapterTitle0" style="text-indent: 0%;"><a id="page09"><span class="xrefInternal"></span></a><a href="#/004TOC#preface_page"><span class="bold">PREFACE</span></a></h2></div>
<div class="chapterBody">
<p class="chapterOpenerText" style="text-indent:0%;"><span class="chapterOpenerFirstLetters"><span class="bold">I</span></span>n case you’re wondering why I’ve chosen now to write my memoir, let me make something clear right up front: I’m not retiring, and I’m certainly not going Home yet. I’ve got far too much left to do.</p>
<p class="para" style="text-indent:5%;">The simple answer to “Why now?” is that I’ve decided I’m ready to talk about my life and my work in my own words. In fact, I may make a habit of doing this every seventy-three years whether I need to or not.</p>
<p class="para" style="text-indent:5%;">To some of you who’ve read my other books and/or come to my lectures, many of the stories in this book will be familiar. To all of you, I promise there are stories in this book you’ve never read or heard before, stories we can all laugh about and cry about and learn from together.</p>
<p class="para" style="text-indent:5%;">I’ve included overviews of many of my philosophies and psychic experiences in these memoirs, and if you find yourselves wanting to read more about any or all of them, know that I’ve written entire books about each and every one of them. I’ve even written entire books about the fact that there’s a Father God and a Mother God, by the way. So please don’t let it throw you that for the majority of this book I refer to God simply, with male pronouns. The alternative is to use the word They, or He/She, which is just plain annoying. Be<a id="page10">sides, I don’t believe for a moment that They care what we call Him/Her, as long as we commit our lives to His/Her service. (See what I mean? In writing, as in life, get too bogged down with technicalities and you miss the whole point.)</a></p><a id="page10">
<p class="para" style="text-indent:5%;">For the most part, though, this book isn’t about the spiritual psychic I am. It’s about the woman I am, not remotely psychic about myself. When I look back on this particular incarnation, I’m as mystified as you might be at the choices in my life that actually seemed like a good idea at the time. If you’ll forgive the cliché, this isn’t the story of a victim; it’s the story of a survivor, flaws, missteps, and all.</p>
<p class="para" style="text-indent:5%;">It’s coming straight from my soul to yours, and I truly hope you enjoy it.</p>
<p class="chapterByline"><img alt="image" class="epubimage" src="Images/10.jpg"/></p>
</a></div><a id="page10">
</a></div>
<a id="page10">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 005prefacepage.vue?0f830f30